import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { fetchProductsFromSheet } from "../../utils/sheetProducts";
import { INSTAGRAM_URL } from "../../config/site";
import { ProductImageWithFallbacks } from "../ProductImageWithFallbacks";

export default function HomeSocialGallery() {
  const [tiles, setTiles] = useState([]);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const products = await fetchProductsFromSheet();
        if (cancelled) return;
        const withImages = products
          .filter((p) => p.images?.length)
          .slice(0, 6)
          .map((p) => ({
            id: p.id,
            name: p.name,
            urls: p.images,
            href: `/product/${p.id}`,
          }));
        setTiles(withImages);
      } catch {
        if (!cancelled) setTiles([]);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  if (tiles.length === 0) return null;

  return (
    <section className="lux-social" aria-labelledby="home-social-heading">
      <div className="lux-section-head">
        <p className="lux-eyebrow">From the collection</p>
        <h2 id="home-social-heading" className="lux-h2">
          Unboxing-worthy presentation
        </h2>
        <a href={INSTAGRAM_URL} className="lux-text-link" target="_blank" rel="noopener noreferrer">
          Follow @rencingifting on Instagram
        </a>
      </div>
      <ul className="lux-social__masonry home-social__grid">
        {tiles.map((tile, i) => (
          <motion.li
            key={tile.id}
            className="lux-social__item"
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-5%" }}
            transition={{ duration: 0.5, delay: (i % 4) * 0.06 }}
          >
            <Link to={tile.href} className="lux-social__card">
              <ProductImageWithFallbacks
                urls={tile.urls}
                alt={`${tile.name} gift box — Rencin Gifting`}
                className="home-social__image"
              />
              <span className="lux-social__overlay">
                <span>View box</span>
              </span>
            </Link>
          </motion.li>
        ))}
      </ul>
    </section>
  );
}
